/**
 * Media Upload Service
 * 
 * Service for temporary file uploads before saving to database
 * Files are uploaded to /static/tmp/ and later moved to final location
 */

import { apiRequest } from '../utils/api';

export interface UploadedFile {
  file: string;        // Relative path: "/tmp/abc-image.jpg"
  url: string;         // Full URL for preview: "http://localhost:8003/static/tmp/abc-image.jpg"
  name: string;        // Original filename
  size: string;        // Formatted size: "1.5 MB"
  mime_type: string;   // MIME type: "image/jpeg"
}

/**
 * Upload file to temporary storage
 * 
 * @param file - File object from input
 * @returns Uploaded file details with preview URL
 * 
 * @example
 * const file = event.target.files[0];
 * const result = await mediaService.uploadTemp(file);
 * // Use result.url for preview
 * // Use result.file when saving form
 */
export const uploadTemp = async (file: File): Promise<UploadedFile> => {
  const formData = new FormData();
  formData.append('file', file);

  return apiRequest<UploadedFile>('/dashboard/media/upload-tmp/', {
    method: 'POST',
    body: formData,
    // Don't set Content-Type header - browser will set it with boundary
  });
};

export const mediaService = {
  uploadTemp,
};
